import { render, staticRenderFns } from "./FileViewVersion.vue?vue&type=template&id=d120c61c&scoped=true&"
import script from "./FileViewVersion.vue?vue&type=script&lang=js&"
export * from "./FileViewVersion.vue?vue&type=script&lang=js&"
import style0 from "./FileViewVersion.vue?vue&type=style&index=0&id=d120c61c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d120c61c",
  null
  
)

export default component.exports